export default "__VITE_ASSET__9IW$vQlk__"